/* Casas Froens v2 - logica de section-tiendas-v2 */
(function () {
function init(root) {
var ID = root.getAttribute('data-sid');
var STORES = (window.cf2Data || {})[ID] || [];
var $ = function (s, c) { return (c || root).querySelector(s); };
var $$ = function (s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); };
var listEl = $('[data-list]'), popEl = $('[data-pop]'), countEl = $('[data-count]');
var state = { f: 'todos', q: '', open: false, near: false, user: null, sel: null, view: 'lista', touched: false };
root.addEventListener('pointerdown', function () { state.touched = true; }, true);
function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[c]; }); }
function norm(s) { return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); }
function toast(msg) { var t = $('[data-toast]'); t.textContent = msg; t.style.display = 'block'; clearTimeout(t._t); t._t = setTimeout(function () { t.style.display = 'none'; }, 4500); }
function parseCode(code) {
if (!code) return null;
var week = [null, null, null, null, null, null, null];
code.split(';').forEach(function (part) {
var m = part.trim().match(/^(\d)(?:-(\d))?@(\d{1,2}):(\d{2})-(\d{1,2}):(\d{2})$/);
if (!m) return;
var a = +m[1], b = m[2] === undefined ? a : +m[2];
var o = +m[3] * 60 + +m[4], c = +m[5] * 60 + +m[6];
for (var d = a; d <= b; d++) week[d] = [o, c];
});
return week;
}
STORES.forEach(function (s) { s.week = parseCode(s.codigo); });
var DIAS = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
function nowCL() {
var p = {};
new Intl.DateTimeFormat('en-US', { timeZone: 'America/Santiago', weekday: 'short', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' })
.formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
var d = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 }[p.weekday];
return { d: d, m: (+p.hour % 24) * 60 + +p.minute };
}
function hhmm(min) { var h = Math.floor(min / 60), m = min % 60; return (h < 10 ? '0' : '') + h + ':' + (m < 10 ? '0' : '') + m; }
function estado(s) {
if (!s.week) return null;
var n = nowCL(), t = s.week[n.d];
if (t && n.m >= t[0] && n.m < t[1]) return { open: true, txt: 'Abierto ahora · hasta las ' + hhmm(t[1]) };
if (t && n.m < t[0]) return { open: false, txt: 'Cerrado · abre hoy a las ' + hhmm(t[0]) };
for (var i = 1; i <= 7; i++) {
var d = (n.d + i) % 7, x = s.week[d];
if (x) return { open: false, txt: 'Cerrado · abre ' + (i === 1 ? 'mañana' : 'el ' + DIAS[d]) + ' a las ' + hhmm(x[0]) };
}
return { open: false, txt: 'Cerrado' };
}
function km(a, b) {
var R = 6371, r = Math.PI / 180, dLa = (b.lat - a.lat) * r, dLo = (b.lng - a.lng) * r;
var h = Math.sin(dLa / 2) * Math.sin(dLa / 2) + Math.cos(a.lat * r) * Math.cos(b.lat * r) * Math.sin(dLo / 2) * Math.sin(dLo / 2);
return 2 * R * Math.asin(Math.sqrt(h));
}
function fmtKm(x) { return x < 10 ? x.toFixed(1).replace('.', ',') + ' km' : Math.round(x) + ' km'; }
function uberUrl(s) {
/* Uber deep link: abre la app con el destino cargado */
var nick = /^froens/i.test(s.nombre) ? s.nombre : 'Froens ' + s.nombre;
var dir = String(s.direccion || '').replace(/\s*\n\s*/g, ', ');
return 'https://m.uber.com/ul/?action=setPickup&pickup=my_location&dropoff[latitude]=' + s.lat + '&dropoff[longitude]=' + s.lng + '&dropoff[nickname]=' + encodeURIComponent(nick) + '&dropoff[formatted_address]=' + encodeURIComponent(dir);
}
function links(s) {
var ll = s.lat + ',' + s.lng, h = '';
h += '<p class="cf2-how">Cómo llegar</p>';
h += '<a class="cf2-btn alt" target="_blank" rel="noopener" href="https://www.google.com/maps/dir/?api=1&destination=' + ll + '">Google Maps</a>';
h += '<a class="cf2-btn alt" target="_blank" rel="noopener" href="https://waze.com/ul?ll=' + ll + '&navigate=yes">Waze</a>';
h += '<a class="cf2-btn alt cf2-uber" target="_blank" rel="noopener" href="' + esc(uberUrl(s)) + '">Uber</a>';
if (s.tel) h += '<a class="cf2-btn alt" href="tel:' + esc(String(s.tel).replace(/[^\d+]/g, '')) + '">Llamar</a>';
return h;
}
function stateHtml(s) {
var e = estado(s);
return e ? '<p class="cf2-state ' + (e.open ? 'is-open' : '') + '"><i></i>' + esc(e.txt) + '</p>' : '';
}
function cardHtml(s) {
return '<article class="cf2-card' + (state.sel === s.id ? ' is-active' : '') + '" data-id="' + esc(s.id) + '">' +
'<div><h2><button type="button" data-sel>' + esc(s.nombre) + '</button></h2>' +
(s.dist != null ? '<p class="cf2-dist">A ' + fmtKm(s.dist) + ' de ti</p>' : '') +
stateHtml(s) +
'<p class="cf2-meta"><b>Dirección:</b> ' + esc(s.direccion) + '</p>' +
'<p class="cf2-meta"><b>Horario:</b> ' + esc(s.horario) + '</p></div>' +
(s.img ? '<img src="' + esc(s.img) + '" alt="Tienda ' + esc(s.nombre) + '" loading="lazy" width="112" height="112">' : '') +
'<div class="cf2-actions">' + links(s) + '<button type="button" class="cf2-btn alt vermapa" data-vermapa>Ver en el mapa</button></div></article>';
}
function visibles() {
var q = norm(state.q);
var out = STORES.filter(function (s) {
if (state.f === 'rm' && s.region !== 13) return false;
if (state.f === 'otros' && s.region === 13) return false;
if (q && norm(s.nombre + ' ' + s.direccion).indexOf(q) === -1) return false;
if (state.open) { var e = estado(s); if (!e || !e.open) return false; }
return true;
});
STORES.forEach(function (s) { s.dist = state.user ? km(state.user, s) : null; });
if (state.near && state.user) out.sort(function (a, b) { return a.dist - b.dist; });
return out;
}
function render(fit) {
var list = visibles();
countEl.textContent = list.length === STORES.length ? STORES.length + ' tiendas' : 'Mostrando ' + list.length + ' de ' + STORES.length + ' tiendas';
if (!list.length) {
listEl.innerHTML = '<div class="cf2-empty">No encontramos tiendas con esos filtros.<br><button type="button" class="cf2-btn alt" data-reset>Ver todas las tiendas</button></div>';
} else {
listEl.innerHTML = list.map(cardHtml).join('');
}
MAP.show(list.map(function (s) { return s.id; }));
if (fit !== false) {
if (state.near && state.user && list.length) MAP.fit(list.slice(0, 3).concat([{ lat: state.user.lat, lng: state.user.lng }]));
else if (list.length) MAP.fit(state.f === 'todos' && !state.q && !state.open ? STORES.filter(function (s) { return s.region === 13; }) : list);
}
if (state.sel && !list.some(function (s) { return s.id === state.sel; })) closePop();
}
function select(id, pan) {
var s = STORES.filter(function (x) { return x.id === id; })[0];
if (!s) return;
state.sel = id;
$$('.cf2-card').forEach(function (c) { c.classList.toggle('is-active', c.getAttribute('data-id') === id); });
MAP.active(id);
if (pan !== false) MAP.focus(s);
popEl.innerHTML = '<button type="button" class="cf2-pop-x" data-x aria-label="Cerrar">×</button><h3>' + esc(s.nombre) + '</h3>' + stateHtml(s) +
'<p class="cf2-meta"><b>Dirección:</b> ' + esc(s.direccion) + '</p><p class="cf2-meta"><b>Horario:</b> ' + esc(s.horario) + '</p><div class="cf2-actions">' + links(s) + '</div>';
popEl.classList.add('on');
}
function closePop() { state.sel = null; popEl.classList.remove('on'); MAP.active(null); $$('.cf2-card').forEach(function (c) { c.classList.remove('is-active'); }); }
function setView(v) {
state.view = v; root.setAttribute('data-view', v);
$$('[data-v]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-v') === v ? 'true' : 'false'); });
if (v === 'mapa') setTimeout(function () { MAP.resize(); var l = visibles(); if (state.sel) { var s = STORES.filter(function (x) { return x.id === state.sel; })[0]; if (s) MAP.focus(s); } else if (l.length) MAP.fit(l); }, 60);
}
var MAP = (function () {
var mapEl = $('[data-map]'), kind = null, map = null, mk = {}, meMk = null, queue = [], ready = false, gTimer = null;
function pinEl(s) { var w = document.createElement('span'); w.className = 'cf2-pinwrap'; w.innerHTML = '<span class="cf2-pin"></span>'; w.title = s.nombre; return w; }
function flush() { ready = true; queue.splice(0).forEach(function (f) { f(); }); settle(); }
function settle() {
var t0 = Date.now();
[150, 600, 1400].forEach(function (ms) {
setTimeout(function () {
if (!map || Date.now() - t0 > 2500 || state.touched) return;
if (kind === 'osm') map.invalidateSize();
render(true);
}, ms);
});
}
function when(f) { if (ready) f(); else queue.push(f); }
function addMarkers() {
STORES.forEach(function (s) {
if (isNaN(s.lat) || isNaN(s.lng)) return;
var el = pinEl(s), m;
if (kind === 'google') {
m = new google.maps.marker.AdvancedMarkerElement({ map: map, position: { lat: s.lat, lng: s.lng }, content: el, title: s.nombre });
m.addListener('click', function () { select(s.id, false); });
mk[s.id] = { m: m, el: el };
} else {
m = L.marker([s.lat, s.lng], { icon: L.divIcon({ className: '', html: el.outerHTML, iconSize: [30, 30], iconAnchor: [15, 30] }), title: s.nombre, keyboard: true }).addTo(map);
m.on('click', function () { select(s.id, false); });
mk[s.id] = { m: m, el: null };
}
});
}
function startOSM() {
if (kind === 'osm') return;
clearTimeout(gTimer);
kind = 'osm'; ready = false; map = null; mk = {}; meMk = null;
var fresh = document.createElement('div'); fresh.className = 'cf2-map'; fresh.setAttribute('data-map', '');
mapEl.parentNode.replaceChild(fresh, mapEl); mapEl = fresh;
function go() {
map = L.map(mapEl, { zoomControl: true, scrollWheelZoom: false }).setView([-33.41, -70.58], 11);
L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', { maxZoom: 19, attribution: '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener">OpenStreetMap</a>' }).addTo(map);
map.on('click', function () { map.scrollWheelZoom.enable(); });
addMarkers(); flush(); render(true);
if (state.sel) select(state.sel, false);
if (state.user) MAP.me(state.user);
}
if (window.L) return go();
var css = document.createElement('link'); css.rel = 'stylesheet'; css.href = 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/leaflet.min.css'; document.head.appendChild(css);
var js = document.createElement('script'); js.src = 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/leaflet.min.js'; js.onload = go;
js.onerror = function () { mapEl.innerHTML = '<div class="cf2-empty">No pudimos cargar el mapa. Usa la lista para encontrar tu tienda.</div>'; };
document.head.appendChild(js);
}
function startGoogle(key, mapId) {
kind = 'google';
window.gm_authFailure = function () { startOSM(); };
var ce = console.error;
console.error = function () {
try { if (kind === 'google' && /Google Maps JavaScript API error/.test(String(arguments[0]))) setTimeout(startOSM, 0); } catch (e) {}
return ce.apply(console, arguments);
};
window.cf2GmInit = function () {
Promise.all([google.maps.importLibrary('maps'), google.maps.importLibrary('marker')]).then(function () {
if (kind !== 'google') return;
map = new google.maps.Map(mapEl, { center: { lat: -33.41, lng: -70.58 }, zoom: 11, mapId: mapId || 'DEMO_MAP_ID', disableDefaultUI: true, zoomControl: true, fullscreenControl: true, gestureHandling: 'cooperative', clickableIcons: false });
addMarkers(); flush(); render(true);
var loaded = false, vis = 0;
google.maps.event.addListenerOnce(map, 'tilesloaded', function () { loaded = true; });
var iv = setInterval(function () {
if (loaded || kind !== 'google') return clearInterval(iv);
if (mapEl.offsetWidth > 0) vis++;
if (vis >= 10 || mapEl.querySelector('.gm-err-container')) { clearInterval(iv); startOSM(); }
}, 1000);
}).catch(startOSM);
};
var sc = document.createElement('script');
sc.src = 'https://maps.googleapis.com/maps/api/js?key=' + encodeURIComponent(key) + '&callback=cf2GmInit&loading=async&v=weekly';
sc.async = true; sc.onerror = startOSM; document.head.appendChild(sc);
gTimer = setTimeout(function () { if (!ready) startOSM(); }, 9000);
}
return {
start: function () {
var key = (new URLSearchParams(location.search).get('cf2key')) || root.getAttribute('data-gkey'), mid = root.getAttribute('data-mapid');
if (key) startGoogle(key, mid); else startOSM();
},
show: function (ids) {
when(function () {
Object.keys(mk).forEach(function (id) {
var on = ids.indexOf(id) > -1, o = mk[id];
if (kind === 'google') o.m.map = on ? map : null;
else if (on) o.m.addTo(map); else o.m.remove();
});
});
},
active: function (id) {
when(function () {
Object.keys(mk).forEach(function (k) {
var el = kind === 'google' ? mk[k].el : (mk[k].m.getElement() && mk[k].m.getElement().querySelector('.cf2-pinwrap'));
if (el) el.classList.toggle('is-active', k === id);
});
});
},
focus: function (s) {
when(function () {
if (kind === 'google') { map.panTo({ lat: s.lat, lng: s.lng }); if (map.getZoom() < 14) map.setZoom(15); }
else map.setView([s.lat, s.lng], Math.max(map.getZoom(), 15), { animate: true });
});
},
fit: function (pts) {
pts = pts.filter(function (p) { return !isNaN(p.lat) && !isNaN(p.lng); });
if (!pts.length) return;
when(function () {
if (pts.length === 1) return MAP.focus(pts[0]);
if (kind === 'google') {
var b = new google.maps.LatLngBounds(); pts.forEach(function (p) { b.extend({ lat: p.lat, lng: p.lng }); }); map.fitBounds(b, 48);
} else map.fitBounds(L.latLngBounds(pts.map(function (p) { return [p.lat, p.lng]; })), { padding: [40, 40], maxZoom: 15 });
});
},
me: function (u) {
when(function () {
var el = document.createElement('span'); el.className = 'cf2-me';
if (kind === 'google') { if (meMk) meMk.map = null; meMk = new google.maps.marker.AdvancedMarkerElement({ map: map, position: u, content: el, title: 'Tu ubicación' }); }
else { if (meMk) meMk.remove(); meMk = L.marker([u.lat, u.lng], { icon: L.divIcon({ className: '', html: el.outerHTML, iconSize: [16, 16], iconAnchor: [8, 8] }), interactive: false }).addTo(map); }
});
},
resize: function () {
if (!map) return;
if (kind === 'google') google.maps.event.trigger(map, 'resize'); else map.invalidateSize();
}
};
})();
var tq;
$('[data-q]').addEventListener('input', function (e) { clearTimeout(tq); var v = e.target.value; tq = setTimeout(function () { state.q = v; render(); }, 120); });
$$('[data-f]').forEach(function (b) {
b.addEventListener('click', function () {
state.f = b.getAttribute('data-f');
$$('[data-f]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
render();
});
});
$('[data-open]').addEventListener('click', function (e) {
state.open = !state.open; e.currentTarget.setAttribute('aria-pressed', state.open ? 'true' : 'false'); render();
});
$('[data-near]').addEventListener('click', function (e) {
var b = e.currentTarget;
if (state.near) { state.near = false; b.setAttribute('aria-pressed', 'false'); render(); return; }
if (!navigator.geolocation) return toast('Tu navegador no permite usar la ubicación.');
b.setAttribute('aria-pressed', 'true');
navigator.geolocation.getCurrentPosition(function (pos) {
state.user = { lat: pos.coords.latitude, lng: pos.coords.longitude };
state.near = true; MAP.me(state.user); render(); listEl.scrollTop = 0;
}, function () {
b.setAttribute('aria-pressed', 'false'); state.near = false;
toast('No pudimos acceder a tu ubicación. Revisa el permiso del navegador o busca por comuna.');
}, { enableHighAccuracy: false, timeout: 10000, maximumAge: 300000 });
});
root.addEventListener('click', function (e) {
var t = e.target, card = t.closest && t.closest('.cf2-card');
if (t.closest('[data-reset]')) { state.f = 'todos'; state.q = ''; state.open = false; $('[data-q]').value = ''; $$('[data-f]').forEach(function (x) { x.setAttribute('aria-pressed', x.getAttribute('data-f') === 'todos' ? 'true' : 'false'); }); $('[data-open]').setAttribute('aria-pressed', 'false'); render(); return; }
if (t.closest('[data-x]')) return closePop();
if (t.closest('[data-vermapa]') && card) { select(card.getAttribute('data-id')); return setView('mapa'); }
if (t.closest('[data-sel]') && card) return select(card.getAttribute('data-id'));
var v = t.closest('[data-v]'); if (v) setView(v.getAttribute('data-v'));
});
render(false);
MAP.start();
setInterval(function () { if (!document.hidden) { var y = listEl.scrollTop; render(false); listEl.scrollTop = y; } }, 60000);
}
Array.prototype.slice.call(document.querySelectorAll('.cf2-root')).forEach(init);
})();